import { AbsDropDown, Input, Label } from "abs-ui-components";
import { MDBCol, MDBRow } from "mdbreact";
import { useEffect, memo } from "react";
import { Controller, useFormContext } from "react-hook-form";

const BlendFields = ({ fuelClassification, fuel, isEditMode }) => {
    const {
        control,
        handleSubmit,
        formState: { errors },
        getValues,
        clearErrors,
        watch,
        reset,
    } = useFormContext();


    useEffect(() => {
        if (fuelClassification === "Blend") {
            var existingFuel = getValues();
            reset(
                {
                    ...existingFuel,      
                    code: fuel?.code ?? "BLEND",
                    name: fuel?.name ?? "",
                    imoCfCo2: fuel?.imoCfCo2 ?? "",
                    ukMrvEfCo2: fuel?.ukMrvEfCo2 ?? "",
                    blendCode: fuel?.blendCode ?? "",
                },
                { keepDirty: false, keepErrors: false }
            );
            clearErrors();
        }
    }, []);

    const onSubmit = (data) => {
        console.log("Form submitted:", data);
    };

    var fuelCodes = [
        "HFO",
        "LFO",
        "MDO",
        "MGO",
        "LNG",
        "ETHANE",
        "LPGP",
        "LPGB",
        "H2",
        "NH3",
        "METH",
        "BIOE",
        "BIOD",
        "HVO",
        "BIOL",
        "BIOM",
        "BIOO",
        "BIOH2",
        "EDO",
        "EMETH",
        "ELNG",
        "EH2",
        "ENH3",
        "ELPG",
        "EDME",
        "Blend",
        "FAME",
        "OTHER"
    ];
    let currentFuelCode = watch("code");

    const fuelCodeOptions = [
        ...fuelCodes,
        ...(currentFuelCode && !fuelCodes.includes(currentFuelCode)
            ? [currentFuelCode]
            : [])
    ].map(item => ({ label: item, value: item }));

    return (
        <div className="fuel-registry mt-5">
            <form onSubmit={handleSubmit(onSubmit)}>
                <MDBRow className="mb-4">
                    <MDBCol>

                        <Label bold required name="Fuel Code" className="mb-1" />
                        <Controller
                            name="code"
                            control={control}
                            rules={{ required: "Fuel Code is required" }}
                            render={({ field, fieldState: { error } }) => (
                                <div>
                                    <AbsDropDown
                                        options={fuelCodeOptions}
                                        selected={field.value}
                                        handleChange={(selected) => {
                                            const value = selected?.value ?? "";
                                            field.onChange(value);
                                        }}
                                        disabled={fuelClassification === "Blend"}
                                        placeholder="Select Fuel Code"
                                        isClearable

                                    />

                                </div>
                            )}
                        />


                    </MDBCol>
                    <MDBCol>
                        <Label bold required name="Fuel Name" className="mb-1" />
                        <Controller
                            name="name"
                            control={control}
                            rules={{
                                required: "Fuel Name is required"
                            }}
                            render={({ field }) => (
                                <div style={{ width: "150px" }}>
                                    <Input
                                        {...field}
                                        style={{ width: "150px" }}
                                        variant="outlined"
                                        size="small"
                                        error={!!errors.name}
                                        disabled={isEditMode}
                                    />
                                </div>
                            )}
                        />
                        {errors.name && (
                            <div className="error-msg">
                                {errors.name.message}
                            </div>
                        )}
                    </MDBCol>
                    <MDBCol>
                        <Label bold required name="BDN ID" className="mb-1" />
                        <Controller
                            name="bdnId"
                            control={control}
                            rules={{
                                required: "BDN ID is required"
                            }}
                            render={({ field }) => (
                                <div style={{ width: "150px" }}>
                                    <Input
                                        {...field}
                                        style={{ width: "150px" }}
                                        variant="outlined"
                                        size="small"
                                        error={!!errors.bdnId}
                                    />
                                </div>
                            )}
                        />
                        {errors.bdnId && (
                            <div className="error-msg">
                                {errors.bdnId.message}
                            </div>
                        )}
                    </MDBCol>

                </MDBRow>
                <MDBRow className="mb-4">
                    <MDBCol>
                        <Label bold required name="IMO CF CO2" className="mb-1" />
                        <Controller
                            name="imoCfCo2"
                            control={control}
                            rules={{
                                required: "IMO CF CO2 is required"
                            }}
                            render={({ field }) => (
                                <div style={{ width: "150px" }}>
                                    <Input
                                        {...field}
                                        type="Number"
                                        style={{ width: "150px" }}
                                        variant="outlined"
                                        size="small"
                                        error={!!errors.imoCfCo2}
                                        disabled={true}
                                    />
                                </div>
                            )}
                        />
                        {errors.imoCfCo2 && (
                            <div className="error-msg">
                                {errors.imoCfCo2.message}
                            </div>
                        )}
                    </MDBCol>
                    <MDBCol>
                        <Label bold required name="UK MRV EF CO2" className="mb-1" />
                        <Controller
                            name="ukMrvEfCo2"
                            control={control}
                            rules={{
                                required: "UK MRV EF CO2 is required"
                            }}
                            render={({ field }) => (
                                <div style={{ width: "150px" }}>
                                    <Input
                                        {...field}
                                        type="Number"
                                        style={{ width: "150px" }}
                                        variant="outlined"
                                        size="small"
                                        error={!!errors.ukMrvEfCo2}
                                        disabled={true}
                                    />
                                </div>
                            )}
                        />
                        {errors.ukMrvEfCo2 && (
                            <div className="error-msg">
                                {errors.ukMrvEfCo2.message}
                            </div>
                        )}
                    </MDBCol>
                    <MDBCol>
                        <Label bold name="Blend Code" className="mb-1" />
                        <Controller
                            name="blendCode"
                            control={control}
                            render={({ field }) => (
                                <div style={{ width: "150px" }}>
                                    <Input
                                        {...field}
                                        type="text"
                                        style={{ width: "150px" }}
                                        variant="outlined"
                                        size="small"
                                        disabled={true}
                                    />
                                </div>
                            )}
                        />
                    </MDBCol>
                    <MDBCol />
                </MDBRow>
            </form>
        </div>
    );
}


//export default BlendFields;
export default memo(BlendFields);
